function confirmWA(payload) {
    var WA = `
        ¡Hola ${payload.patient_first_name}! 
        \n\n Tu consulta esta confirmada con ${payload.doctor_name} 
        \n\n Nombre del paciente: ${payload.patient_name} 
        \n ${payload.date_time} 
        \n\n En clínica: ${payload.clinic_name} 
        \n Dirección: ${payload.clinic_address}\n\n No. Consulta: ${payload.consultation_id}
    `
    return WA
}

export { confirmWA }